import { useTranslations } from 'next-intl'

import { UserType } from '../model/user'

export const useUserType = () => {
  const t = useTranslations('account')

  const USER_TYPE_MAP: Record<UserType, string> = {
    [UserType.GUEST]: t('profile.role.tenant'),
    [UserType.HOST]: t('profile.role.landlord'),
  }

  return {
    USER_TYPE_MAP,
  }
}
